import { styled } from '@mui/material/styles';
import React from 'react';
import { Button } from '@mui/material';
import { getRobotsValue } from '../../services/utils';
import { Helmet } from 'react-helmet';
import { AppBar } from '@lialo/pwa-ui/lib/PageComponents/AppBar';
import DrawerMenu from '../../common/Page/AppBarButtons/DrawerMenu';
import { Page } from '@lialo/pwa-ui/lib/PageComponents/Page';
import { useTranslation } from 'react-i18next';
import { EmptyPageNotice } from '@lialo/pwa-ui/lib/EmptyPageNotice';
import { Link } from 'react-router-dom';
import routes from '@lialo/core/lib/pages/utils/routes';
import { useServiceProvider } from '../../common/Providers';

const PREFIX = 'NotFoundPage';

const classes = {
  content: `${PREFIX}-content`,
  button: `${PREFIX}-button`,
};

const StyledPage = styled(Page)(({ theme }) => ({
  [`& .${classes.content}`]: {
    justifyContent: 'center',
    alignItems: 'center',
  },

  [`& .${classes.button}`]: {
    marginTop: theme.spacing(2),
  },
}));

interface IProps {}

const NotFoundPage = (props: IProps) => {
  const { t } = useTranslation();
  const { navigationService } = useServiceProvider();

  return (
    <StyledPage>
      <Helmet>
        <meta name="robots" content={getRobotsValue('noindex,nofollow')} />
      </Helmet>
      <AppBar title={t('not_found.title')} leftElement={<DrawerMenu />} />
      <EmptyPageNotice line1={t('not_found.line1')} line2={t('not_found.line2')}>
        <Button
          className={classes.button}
          component={Link}
          to={navigationService.generateI18nPath(routes.ROOT)}
          variant="contained"
          color="secondary"
        >
          {t('not_found.cta')}
        </Button>
      </EmptyPageNotice>
    </StyledPage>
  );
};

export default NotFoundPage;
